import useStore from "../../../store"
import { useEffect, useState, useRef } from "react"
import Spinner from "../../common/Spinner"
import { HappyButton } from "../../common/Buttons"
import { useTranslation } from "react-i18next"

export default function UnitTitleDownload({ unit }) {
  const fetchUnitTitle = useStore((state) => state.fetchUnitTitle)
  const setErrMessage = useStore((state) => state.setErrMessage)
  const pdfDownloadRef = useRef(null)
  const [fetchingTitle, setFetchingTitle] = useState(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    if (pdfDownloadRef && pdfUrl) {
      pdfDownloadRef?.current?.click()
      window.URL.revokeObjectURL(pdfUrl)
      setPdfUrl(null)
    }
  }, [pdfUrl])

  const handleDownloadTitle = async () => {
    setFetchingTitle(true)
    try {
      const response = await fetchUnitTitle(unit.id)
      if (response.status == 200) {
        const data = await response.blob()
        const url = window.URL.createObjectURL(data)
        setPdfUrl(url)
      } else {
        setErrMessage(t('Unable to retrieve title at this time'))
      }
    } catch(err) {
      setErrMessage(t('Unable to retrieve title at this time'))
    } finally {
      setFetchingTitle(false)
    }
  }

  if (!unit.attributes['title-file-url']) {
    return(
      <div
        className="flex w-full justify-center items-center text-center text-grey-100 opacity-75 py-1.5 px-8 border-2 rounded-full"
      >
        {t("Title Unavailable")}
      </div>
    )
  }

  return(
    <>
      <HappyButton
        text={fetchingTitle ? <Spinner color="green" /> : t("Download Title")}
        onClick={handleDownloadTitle}
      />
      <a
        className="display-none"
        download={`title-${unit.attributes.vin}.pdf`}
        href={pdfUrl}
        ref={pdfDownloadRef}
        data-testid='download-title-link'
      />
    </>
  )
}